import { useState } from 'react'

import { Icon } from '@wartek-id/icon'

import AndroidHandler from 'utils/androidHandler'
import { SocialShareDrawer } from 'components/SocialShareDrawer'

import type { SocialFunnel } from 'components/SocialShareDrawer'
import type { FC } from 'react'

interface ShareProps {
  title: string
  shareMessage: string
  shareUrl: string
  onShare?: (funnel: SocialFunnel) => void
}

const Share: FC<ShareProps> = ({
  title = 'Bagikan Cerita Praktik',
  shareMessage,
  shareUrl,
  onShare,
}: ShareProps) => {
  const androidHandler = AndroidHandler()
  const [isShareDialogOpen, setShareDialogOpen] = useState(false)

  const triggerShareDialog = () => {
    if (androidHandler.enabled) {
      androidHandler.shareToolkitUrl(`${shareMessage} ${shareUrl}`)
    } else {
      setShareDialogOpen(true)
    }
  }

  return (
    <>
      <button type="button" onClick={triggerShareDialog}>
        <Icon>share</Icon>
      </button>

      <SocialShareDrawer
        isOpen={isShareDialogOpen}
        title={title}
        onClose={() => {
          setShareDialogOpen(false)
        }}
        onShareButtonClicked={onShare}
        linkOnlyOnCopy={true}
        shareText={shareMessage}
        shareUrl={shareUrl}
      />
    </>
  )
}
export default Share
